import { render, staticRenderFns } from "./wenfangCard.vue?vue&type=template&id=61e7a12b&scoped=true"
import script from "./wenfangCard.vue?vue&type=script&lang=ts"
export * from "./wenfangCard.vue?vue&type=script&lang=ts"
import style0 from "./wenfangCard.vue?vue&type=style&index=0&id=61e7a12b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e7a12b",
  null
  
)

export default component.exports